import Box from '@mui/material/Box';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import type { SxProps } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import type { FC } from 'react';

type Props = {
  sx?: SxProps;
};

const ProductLoading: FC<Props> = ({ sx }) => {
  return (
    <Container sx={{ ...sx }}>
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,

          [`.${linearProgressClasses.root}`]: {
            backgroundColor: (theme) => theme.palette.error.light,
            height: '8px',
            [`.${linearProgressClasses.bar}`]: {
              backgroundColor: (theme) => theme.palette.error.main,
            },
          },
        }}
      >
        <LinearProgress />
      </Box>
      <Image alt="logo" src="/gd-nhat-anh.png" />
    </Container>
  );
};

export default ProductLoading;

const Container = styled(Stack)`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const Image = styled('img')`
  width: 40vw;
  animation: fade 2s ease-in-out infinite;

  @keyframes fade {
    0%,
    100% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
    }
  }
`;
